// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__rPrIC","hr":"Modal_hr__ep+xy","paper":"Modal_paper__kd42U","title":"Modal_title__SfYS8","closeButton":"Modal_closeButton__anuVQ"};